<template>
    <div class="table-responsive">
        <table class="table table-hover table-borderless"
                cellspacing="0"
                width="100%">
            <thead>
                <tr>
                    <th>
                        Agence
                    </th>
                    <th>
                        Nom
                    </th>
                    <th>
                        Prix
                    </th>
                    <th>
                        Quantité
                    </th>
                    <th>
                        Opérations
                    </th>
                </tr>
            </thead>
            <tbody>
                <catalog-dom-item v-for="offer in catalog"
                                    :key="'catalog-dom-offer-'+offer.id"
                                    :offer="offer"
                                    @add="$emit('add', $event)"
                                    :mayupdate="mayupdate"
                                    @crushcart="$emit('crushcart', $event)">
                </catalog-dom-item>
            </tbody>
        </table>
    </div>
</template>

<script>
    import CatalogDomItem from './CatalogDomItem.vue'

    export default {

        props: ["catalog", "mayupdate"],

        components: {
            CatalogDomItem
        },

        data: function () {
            return {}
        }

    }

</script>

<style>

</style>



// WEBPACK FOOTER //
// client/components/Catalog/CatalogDom.vue